// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costTableRowColor:hover {
    background-color: rgba(239,239,239,0.5);
    cursor: pointer;
}

.asdf{
    color: red;
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
  
  ul {
    list-style: none;
    padding: 0;
  }
  
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
  }

  ul.pagination li:first-child{
    border-radius: 5px 0 0 5px;
  }

  ul.pagination li:last-child{
    border-radius: 0 5px 5px 0;
  }
  
  ul.pagination li a {
    text-decoration: none;
    color: #337ab7;
    font-size: 1rem;
  }
  
  ul.pagination li.active a {
    color: white;
  }

  ul.pagination li.active {
    background-color: #337ab7;
  }
  
  ul.pagination li a:hover,
  ul.pagination li a.active {
    color: blue;
  }
  
  .page-selection {
    width: 48px;
    height: 30px;
    color: #337ab7;
  }

  .iconAni {
    position: relative;
    animation: bounce 2s infinite;
    transform-origin: bottom;
  }
  
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    25% {
      transform: translateY(-10px);
    }
    50% {
      transform: translateY(0);
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/Cost/CostSt.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA;IACE;MACE,wBAAwB;IAC1B;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,wBAAwB;IAC1B;EACF","sourcesContent":[".costTableRowColor:hover {\n    background-color: rgba(239,239,239,0.5);\n    cursor: pointer;\n}\n\n.asdf{\n    color: red;\n}\n\n.pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 15px;\n  }\n  \n  ul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  ul.pagination li {\n    display: inline-block;\n    width: 30px;\n    height: 30px;\n    border: 1px solid #e2e2e2;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1rem;\n  }\n\n  ul.pagination li:first-child{\n    border-radius: 5px 0 0 5px;\n  }\n\n  ul.pagination li:last-child{\n    border-radius: 0 5px 5px 0;\n  }\n  \n  ul.pagination li a {\n    text-decoration: none;\n    color: #337ab7;\n    font-size: 1rem;\n  }\n  \n  ul.pagination li.active a {\n    color: white;\n  }\n\n  ul.pagination li.active {\n    background-color: #337ab7;\n  }\n  \n  ul.pagination li a:hover,\n  ul.pagination li a.active {\n    color: blue;\n  }\n  \n  .page-selection {\n    width: 48px;\n    height: 30px;\n    color: #337ab7;\n  }\n\n  .iconAni {\n    position: relative;\n    animation: bounce 2s infinite;\n    transform-origin: bottom;\n  }\n  \n  @keyframes bounce {\n    0%, 100% {\n      transform: translateY(0);\n    }\n    25% {\n      transform: translateY(-10px);\n    }\n    50% {\n      transform: translateY(0);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
